import { render, staticRenderFns } from "./SponsoredRecommendationTitleList.vue?vue&type=template&id=0e55f12f&scoped=true"
import script from "./SponsoredRecommendationTitleList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationTitleList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationTitleList.vue?vue&type=style&index=0&id=0e55f12f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e55f12f",
  null
  
)

export default component.exports